import { Link } from "react-router-dom";
import * as CSC from "SC";
import { CommonOutletTemplate } from "UI/CommonOutletTemplate";

export const SimplifiedSignUpSenderButtonDone = () => {
  return (
    <CommonOutletTemplate noPadding title="Sender Registration">
      <div className="bg-white p-4 sm:p-8 m-8 rounded-2xl flex flex-col justify-center items-center sm:gap-6">
        <div className="text-xl sm:text-2xl font-bold mr-4">
          Button Dashboard creation Successful!
        </div>
        <div>Welcome! You are successfully registered as a new sender.</div>
        <Link to={"/my_button_dashboard"}>
          <CSC.BlueButton variant="contained" sx={{ width: "100%" }}>
            Go to Button Dashboard
          </CSC.BlueButton>
        </Link>
      </div>
    </CommonOutletTemplate>
  );
};
